<template>
  <v-layout row wrap>
    <v-flex xs12 md12>
      <h2 class="display-1 mb-3">My profile</h2>
    </v-flex>
    <v-flex xs12 md12>
      <router-view></router-view>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'profile'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/Profile.vue